export function injectRawPixel(rawHtml) {
    const container = document.createElement('div');
    container.innerHTML = rawHtml;
    container.querySelectorAll('script').forEach(old => {
        const el = document.createElement('script');
        if (old.src) { el.src = old.src; el.async = old.async; }
        else { el.textContent = old.textContent; }
        document.body.appendChild(el);
    });
    container.querySelectorAll('noscript').forEach(ns => {
        const tmp = document.createElement('div');
        tmp.innerHTML = ns.textContent;
        tmp.querySelectorAll('img').forEach(img => document.body.appendChild(img));
    });
}

export function firePixels(pixelTags, trigger) {
    pixelTags
        ?.filter(p => p.trigger === trigger)
        .forEach(p => {
            try { injectRawPixel(p.script); }
            catch (err) { console.error('Pixel error:', err); }
        });
}
